import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { collapsed } from '@/components/sidebar/state'

export default {
    props: {
        to: { type: [String, Object], required: true },
        icon: { type: String, default: '' }
    },

    setup(props, { emit }) {
        const route = useRoute()

        const isActive = computed(() => {
            // если передан name
            if (props.to?.name) {
                return route.matched.some(r => r.name === props.to.name)
            }

            // если передан path
            if (typeof props.to === 'string') {
                return route.path.startsWith(props.to)
            }

            return false
        })

        const handleClick = () => {
            emit('click')
        }

        return {
            isActive,
            collapsed,
            handleClick
        }
    }
}